import { graphql } from "react-apollo";
import CmsBlockQuery from "./CmsBlockQuery.gql";

export default ({ name, slug }) =>
  graphql(CmsBlockQuery, {
    name: name,
    options: {
      variables: {
        identifiers: [slug],
      },
    },
    props: (data) => ({
      [name]: {
        loading: data[name].loading,
        data:
          !data[name].loading &&
          data[name].cmsBlockList &&
          data[name].cmsBlockList.find(
            (block) => block && block.identifier === slug
          ),
      },
    }),
  });
